import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { legalTranslations } from '../lib/i18n/legal';
import { useI18n } from '../i18n';

export default function PrivacyPolicy() {
  const { lang } = useI18n();
  const content = legalTranslations[lang].privacy;
  const ui = legalTranslations[lang].ui;

  return (
    <LegalLayout
      title={content.title}
      intro={content.intro}
      sections={content.sections}
      metaTitle={content.metaTitle}
      metaDescription={content.metaDesc}
      tocTitle={ui.toc}
      lastUpdatedText={ui.lastUpdated}
    />
  );
}